import { FC } from "react";
import PrepStateReleasedSvg from "../../public/icons/PrepStateReleased.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const GeometryBuildUpStateReleasedIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><PrepStateReleasedSvg/></span>;
